import { type Ad, type AdSize } from '@/entities/ad-banner/model/wrapper-ads.types';

import { ApiService } from '../ApiService';

export const getAds = async (): Promise<Ad[]> => {
  const { data } = await ApiService.instance.request<Ad[]>({
    method: 'GET',
    url: 'v1/promo/avd/one',
  });
  return data;
};

export const updateAdShow = async (adId: number) => {
  return await ApiService.instance.put(`v1/promo/${adId}/show`);
};

export const updateAdClick = async (adId: number) => {
  return await ApiService.instance.put(`v1/promo/${adId}/click`);
};

export const getAdverts = ({ size, limit }: { size?: AdSize; limit?: number } = {}) => {
  const queryParams = new URLSearchParams();

  if (size) queryParams.append('size', size);
  if (limit !== undefined) queryParams.append('limit', limit.toString());

  return ApiService.instance
    .get<Ad[]>(`v1/promo/avd${queryParams.size ? `?${queryParams.toString()}` : ''}`)
    .then((res) => res.data);
};

export const clickAdvert = (advertId: number) => {
  return ApiService.instance
    .put<void>(`v1/promo/${advertId}/click`)
    .then((res) => res.data);
};

export const showAdvert = (advertId: number) => {
  return ApiService.instance
    .put<void>(`v1/promo/${advertId}/show`)
    .then((res) => res.data);
};
